import { AdminUserRealm } from 'further-types/admin-user';
import api from 'lib/trpcClient';

export default function useAvailableVehicles(realm?: AdminUserRealm) {
  const { data: vehicles, isLoading } = api.vehicle.listAllVehicles.useQuery(
    {
      order: 'desc',
      orderBy: 'vehicleName',
    },
    {
      enabled: realm === AdminUserRealm.Lp,
    },
  );

  return {
    availableVehicles: vehicles?.result ?? [],
    isLoading,
  };
}
